import { useEffect, useRef, useState } from 'react';

import { inactivityHandler, ToastId } from 'helpers/inactivityHandler/inactivityHandler';

export const useInactivityHandler = (isUserAuth: boolean) => {
  const inactivityWorkerRef = useRef<Worker | null>(null);
  const [toastId, setToastId] = useState<ToastId>(null);

  useEffect(() => {
    const resetIdleTimer = () => {
      inactivityHandler.closeToast(toastId);
      inactivityWorkerRef.current?.postMessage('reset');
    };

    if (isUserAuth) {
      inactivityWorkerRef.current = new Worker(
        new URL('helpers/inactivityHandler/inactivityWorker.js', import.meta.url),
      );

      inactivityWorkerRef.current.onmessage = (e) => {
        if (e.data === 'notify') {
          inactivityHandler.toast(setToastId);
        }

        if (e.data === 'logout') {
          inactivityHandler.signOut(toastId);
        }
      };

      window.addEventListener('mousemove', resetIdleTimer);
      window.addEventListener('keydown', resetIdleTimer);
      window.addEventListener('click', resetIdleTimer);
    } else {
      inactivityWorkerRef.current?.terminate();
      window.removeEventListener('mousemove', resetIdleTimer);
      window.removeEventListener('keydown', resetIdleTimer);
      window.removeEventListener('click', resetIdleTimer);
    }

    return () => {
      inactivityWorkerRef.current?.terminate();
      window.removeEventListener('mousemove', resetIdleTimer);
      window.removeEventListener('keydown', resetIdleTimer);
      window.removeEventListener('click', resetIdleTimer);
    };
  }, [isUserAuth, toastId]);
};
